export const errors = {
    story: "Please fill in success story",
    comment: "Please fill in a comment",
  };